/**
 * @generated SignedSource<<acf74da72645db0461952f962601ccb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompaniesTable_organization$data = {
  readonly slug: string;
  readonly companies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly deletedAt: any | null;
        readonly " $fragmentSpreads": FragmentRefs<"CompaniesTableRow_company" | "CompanyContextMenu_company">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "CompaniesTable_organization";
};
export type CompaniesTable_organization$key = {
  readonly " $data"?: CompaniesTable_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompaniesTable_organization">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "companies"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": "NO",
      "kind": "LocalArgument",
      "name": "includeDeleted"
    },
    {
      "kind": "RootArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./CompaniesTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "CompaniesTable_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "companies",
      "args": [
        {
          "kind": "Variable",
          "name": "includeDeleted",
          "variableName": "includeDeleted"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "order"
        }
      ],
      "concreteType": "CompaniesConnection",
      "kind": "LinkedField",
      "name": "__CompaniesTable_companies_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompaniesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Company",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedAt",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CompaniesTableRow_company"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CompanyContextMenu_company"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "c741f04e6bda71984b44b63df677b2d1";

export default node;
